import { userDataRequest } from '../../lib/userDataRequest';

export const getNotes = (noteableType, noteableId) => {
  return userDataRequest('get', `/notes/${noteableType}/${noteableId}`);
};

export const saveNewNote = (noteableType, noteableId, newNote) => {
  const body = {
    noteableId,
    ...newNote
  };

  return userDataRequest('post', `/notes/${noteableType}`, {}, false, body);
};

export const deleteNoteById = (noteId) => {
  return userDataRequest('delete', `/notes/${noteId}`);
};

export const editNoteById = (noteId, title, contents) => {
  return userDataRequest('patch', `/notes/${noteId}`, {}, false, {title, contents});
};